import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'


$(".faq .content ul li").eq(0).addClass("active");
$(".faq .content ul li .title").click(function() {
     let $dl = $(this).parent().parent();
    if($dl.hasClass("active")){
        $dl.removeClass("active");
    }else{
        $(".faq .content ul li").removeClass("active");
        $dl.addClass("active");
    }
})

$(".faq .content ul li .icon").click(function() {
     let $dl = $(this).parent();
    if($dl.hasClass("active")){
        $dl.removeClass("active");
    }else{
        $(".faq .content ul li").removeClass("active");
        $dl.addClass("active");
    }
})